import React, { useState } from 'react';
import { demoNodes, demoEdges } from '../components/OPMEditorX6Svg/demo-data';
import '../components/OPMEditorX6Svg/styles/index.css';
import OPMEditorX6Svg from '@/components/OPMEditorX6Svg';

const OPMX6DemoPage: React.FC = () => {
  const [status, setStatus] = useState('');

  return (
    <div className="opm-x6-page">
      {/* Header */}
      <div className="opm-x6-page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <h2>OPM Editor — X6 POC</h2>
          <span className="badge">
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#1890ff' }} />
            AntV X6 v3
          </span>
          <span className="badge" style={{ background: '#f6ffed', color: '#52c41a', borderColor: '#b7eb8f' }}>
            仿真演示
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, fontSize: 12, color: '#8c8c8c' }}>
          {status && <span>{status}</span>}
          <span>点击节点选中 | 拖拽创建连线 | 双击编辑标签</span>
        </div>
      </div>

      {/* Graph */}
      <div className="opm-x6-graph-wrapper">
        <OPMEditorX6Svg
          initialNodes={demoNodes}
          initialEdges={demoEdges}
          onStatusChange={setStatus}
        />
      </div>
    </div>
  );
};

export default OPMX6DemoPage;
